module.exports = __webpack_public_path__ + "img/M_Placeholder_Quidel_EN.0c9f8afc.jpg";